export function WardMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <path d="M3 6h6v14l7-7 7 7V6h6v22h-6l-7-7-7 7H3V6Z" fill="currentColor" />
    </svg>
  );
}
